import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { colorsPalette, keyColors } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';

export const textCss = css(typography.effra18, {
  margin: '0 0 32px',
});

export const titleCss = css(typography.effra40, {
  fontWeight: fontWeights.medium,
  margin: '0 0 24px',
  position: 'relative',
});

export const locationsCss = css({
  [MediaQueries.lgAndUp]: {
    margin: '72px 0 0',
  },
});

export const locationCss = css(typography.effra22, {
  display: 'inline',
  lineHeight: 1.45,
});

export const locationLinkCss = theme => {
  const isDarkTheme = theme === keyColors.black;
  const { grey, grey20, grey80, white } = colorsPalette;
  const darkBorderBottom = `1px solid ${grey80}`;
  const lightBorderBottom = `1px solid ${grey20}`;

  return css(typography.effra22, {
    color: isDarkTheme ? white : grey,
    textDecoration: 'none',
    borderBottom: isDarkTheme ? darkBorderBottom : lightBorderBottom,
    [MediaQueries.mdAndUp]: typography.effra28,
  });
};

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const containerPaddingCss = css({
  padding: '64px 0',
  [MediaQueries.md]: {
    padding: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    padding: '160px 0',
  },
});
